import {useBreakpoints as useBreakpointsVueuse} from '@vueuse/core'
import {computed} from 'vue'

/**
 * Breakpoints helper composable
 */
export function useBreakpoints() {

  //Breakpoints
  const {greaterOrEqual} = useBreakpointsVueuse({
    sm: 768,
  })

  //Check if mobile/desktop
  const isDesktop = computed(() => greaterOrEqual('sm').value)
  const isMobile = computed(() => !isDesktop.value)

  //Expose interface
  return {
    isDesktop,
    isMobile,
  }
}
